/**
 * Пагинация
 */

class Pagination {
    constructor(el) {
        this.container = el;
        this.links = el.querySelectorAll('.js-pagination-link');
        this.filter = document.getElementById(this.container.getAttribute('data-filter'));

        this.bindLinks();
    }



    // Кликаем ссылки вперёд-назад
    bindLinks() {
        if (!this.filter) return;

        this.links.forEach(el => {
            const page = el.getAttribute('data-page');

            el.addEventListener('click', (e) => {
                e.preventDefault();
                this.updatePage(page);
            });
        });
    }



    // Отправляем форму
    updatePage(page) {
        /**
         * Сбрасываем форму на случай, если пользователь
         * там что-то выбрал, но не нажал сабмит
         */
        this.filter.reset();

        /**
         * Подставляем в форму значение страницы и отправляем её
         */
        const pageInput = this.filter.querySelector('.js-input-page');
        pageInput.disabled = false;
        pageInput.value = page;
        this.filter.submit();
    }
}

document.querySelectorAll('.js-pagination').forEach(el => {
    new Pagination(el);
});



// WEBPACK FOOTER //
// ./_src/js/Pagination.js